import type { PropsWithChildren } from 'react';

import { Styled } from './illustration.styles';

export const Illustration: React.FC<PropsWithChildren> = ({ children }) => {
  return <Styled.ImageContainer>{children}</Styled.ImageContainer>;
};
